import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, DatePicker, Button, message } from 'antd';
import dayjs from 'dayjs';
import { post } from '../../../../services/ApiService';

// Only dates after today can be scheduled; today or earlier means "send with the next courier run".
const isNotSchedulable = (current) => current && !current.isAfter(dayjs(), 'day');

export const saveDispatchDate = async (orderId, scheduledDispatchDate) => {
  try {
    const res = await post(`api/orders/dispatch-date/${orderId}`, { scheduledDispatchDate });
    if (res.success) {
      message.success(res.message);
      return res.data;
    }
    message.error(res.error || 'Failed to update dispatch date');
  } catch (error) {
    message.error('Failed to update dispatch date');
  }
  return null;
};

const DispatchDateModal = ({ open, onCancel, onSuccess, order }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSave = async (scheduledDispatchDate) => {
    setSubmitting(true);
    const data = await saveDispatchDate(order._id, scheduledDispatchDate);
    setSubmitting(false);
    if (data) onSuccess(data);
  };

  const handleSubmit = ({ scheduledDispatchDate }) =>
    handleSave(scheduledDispatchDate.format('YYYY-MM-DD'));

  return (
    <Modal
      title="Dispatch Date"
      open={open}
      onCancel={onCancel}
      maskClosable={!submitting}
      destroyOnClose
      footer={[
        order?.scheduledDispatchDate && (
          <Button key="clear" danger disabled={submitting} onClick={() => handleSave(null)}>
            Clear Date
          </Button>
        ),
        <Button key="cancel" disabled={submitting} onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={submitting} onClick={form.submit}>
          Save
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          scheduledDispatchDate: order?.scheduledDispatchDate ? dayjs(order.scheduledDispatchDate) : null,
        }}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="scheduledDispatchDate"
          label="Dispatch On"
          extra="The order will not be sent to the courier before this date."
          rules={[{ required: true, message: 'Dispatch date is required' }]}
        >
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" disabledDate={isNotSchedulable} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

DispatchDateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  order: PropTypes.object,
};

export default DispatchDateModal;
